<template>
  <v-dialog :value="open" @input="closeDialog" max-width="600px">
    <v-card style="padding:40px; height:280px">
        <h1 class="primary--text headline" style="font-size:22px;color:rgba(0, 0, 0, 0.6); margin-bottom:20px">Por favor seleccione un periodo: </h1>
        <v-select
        v-model="periodSelected"
        :items="periods"
        item-text="code"
        return-object
        label='Periodo'
        outlined
        @blur="$v.periodSelected.$touch()"
        :error-messages="$v.periodSelected.$anyError ? $t('modules.academic.periods.create.errors.required') : ''"
        >
        </v-select>
        <v-row class="justify-center pt-8">
            <Button
                class="mx-8"
                :text="$t('actions.close')"
                white
                @clicked="$emit('close')"
            ></Button>
            <Button
                class="mx-8"
                :text="$t('actions.next')"
                style="background-color:#106ca7;border-radius:38px"
                @clicked="saveSelectionPeriod"
            ></Button>
        </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/Button/Button';
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'SelectPeriod',
  props: {
    open: { type: Boolean, default: false },
    periods: { type: Array },
    setSelectedPeriod: { type: Function}
  },
  components: {
      Button
  },
  data(){
      return {
        periodSelected: null
      }
  },
  mounted(){
  },
  methods: {
    closeDialog () {
      if (this.open) {
        this.$emit('close');
        }
    },
    saveSelectionPeriod(){
        if(this.$v.$invalid){
            this.$v.$touch()
        }else {
            this.$emit('setSelectedPeriod', this.periodSelected)
        }
    }
  },
  validations: {
      periodSelected: { required }
  }
}
</script>

<style lang="sass" scoped>
  .dialog
    width: 400px
    height: 300px

  .headline
    font-size: 1.5rem !important
    font-weight: 400
    line-height: 2rem
    letter-spacing: normal !important
    font-family: "Roboto", sans-serif !important
</style>